import React from 'react';
import './Experience.css';
import encoded from '../../../Assets/Icons/encoded.jpg';
import tegra from '../../../Assets/Icons/tegra.jpeg'

const Experience = () => {
    return (
        <div className='mb-10 mt-32 lg:mt-10 lg:w-full' id='experience'>
            <h1 className='experience-heading-style ml-5 md:ml-10 lg:ml-0 text-3xl md:text-4xl font-semibold mb-5' data-aos="fade-up">Proffesional Experience</h1>
            <div className="timeline">

                <div className="containerr left-container" data-aos="fade-down">
                    <img className='w-[50px] border-2' src={encoded} alt="" />
                    <div className="text-box shadow-xl shadow-blue-100 rounded-3xl">
                        <h3 className='font-mono text-sky-600'>Web Developer at</h3>
                        <h2 className=''>Encoded Solutions Ltd.</h2>
                        <small>2022 - 2023</small>
                        <p>Collaborated with other developers to improve my skills and to create websites using wordpress. Developed, maintained, and shipped production code for client websites primarily.
                        </p>
                        <span className='left-container-arrow'></span>
                    </div>
                </div>

                <div className="containerr right-container" data-aos="fade-down">
                    <img className='w-[50px]' src={tegra} alt="" />
                    <div className="text-box shadow-xl shadow-blue-100 rounded-3xl">
                        <h3 className='font-mono text-sky-600'>Frontend Developer at</h3>
                        <h2>Tegra Design</h2>
                        <small>2023 - Present</small>
                        <p>As a front-end developer at Tegra Design, I am working with designers to implement their vision for the user interface and staying up-to-date with the latest front-end development technologies and trends.</p>
                        <span className='right-container-arrow'></span>
                    </div>
                </div >

            </div >
        </div >
    );
};

export default Experience;